"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ApiV3DataTransformationBuilder () {
        return ApiV3DataTransformationBuilder;
    },
    get builderGenerator () {
        return builderGenerator;
    },
    get colOptionBuilder () {
        return colOptionBuilder;
    },
    get columnBuilder () {
        return columnBuilder;
    },
    get columnOptionsV3ToV2Builder () {
        return columnOptionsV3ToV2Builder;
    },
    get columnV3ToV2Builder () {
        return columnV3ToV2Builder;
    }
});
const _nocodbsdk = require("nocodb-sdk");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
const convertToSnakeCase = (str)=>{
    return str.replace(/[A-Z]/g, (letter)=>`_${letter.toLowerCase()}`);
};
const convertToCamelCase = (str)=>{
    return str.replace(/_([a-z])/g, (_, letter)=>`${letter.toUpperCase()}`);
};
const columnsWithOptions = [
    _nocodbsdk.UITypes.Lookup,
    _nocodbsdk.UITypes.Links,
    _nocodbsdk.UITypes.LinkToAnotherRecord,
    _nocodbsdk.UITypes.Rollup,
    _nocodbsdk.UITypes.Lookup,
    _nocodbsdk.UITypes.Barcode,
    _nocodbsdk.UITypes.Formula,
    _nocodbsdk.UITypes.QrCode,
    _nocodbsdk.UITypes.Button,
    _nocodbsdk.UITypes.LongText
];
let ApiV3DataTransformationBuilder = class ApiV3DataTransformationBuilder {
    remapColumns(mappings) {
        this.transformations.push((data)=>{
            return Object.entries(data).reduce((result, [key, value])=>{
                const newKey = mappings[key] || key;
                result[newKey] = value;
                return result;
            }, {});
        });
        return this;
    }
    filterColumns(args) {
        this.transformations.push((data)=>{
            return Object.keys(data).filter((key)=>{
                if ('allowed' in args) return args.allowed.includes(key);
                if ('excluded' in args) return !args.excluded.includes(key);
            }).reduce((result, key)=>{
                result[key] = data[key];
                return result;
            }, {});
        });
        return this;
    }
    metaTransform(_0 = void 0) {
        let _ref = [
            _0
        ], [_ref1 = {}] = _ref, { snakeCase = true, camelCase = false, mappings = {}, metaProps = [
            'meta'
        ], skipTransformFor, skipfn } = _ref1, rest = _object_without_properties_loose(_ref1, [
            "snakeCase",
            "camelCase",
            "mappings",
            "metaProps",
            "skipTransformFor",
            "skipfn"
        ]);
        this.transformations.push((data)=>{
            const result = _extends({}, data);
            // iterate and update properties of metaProps only
            for (const prop of metaProps){
                if (result[prop]) {
                    if (typeof result[prop] === 'string') {
                        try {
                            result[prop] = JSON.parse(result[prop]);
                        } catch (unused) {}
                    } else {
                        result[prop] = _extends({}, result[prop]);
                    }
                    result[prop] = Object.entries(result[prop]).filter(([key])=>{
                        if ('excluded' in rest) {
                            return !rest.excluded.includes(key);
                        }
                        if ('allowed' in rest) {
                            return rest.allowed.includes(key);
                        }
                        return true;
                    }).reduce((result, [key, value])=>{
                        let newKey = mappings[key] || key;
                        if (skipTransformFor && skipTransformFor.includes(newKey) || skipfn && skipfn(data)) {
                            result[newKey] = value;
                            return result;
                        }
                        if (camelCase) {
                            newKey = convertToCamelCase(newKey);
                        } else if (snakeCase) {
                            newKey = convertToSnakeCase(newKey);
                        }
                        result[newKey] = value;
                        return result;
                    }, {});
                }
            }
            return result;
        });
        return this;
    }
    customTransform(transformFn) {
        this.transformations.push(transformFn);
        return this;
    }
    build(data) {
        if (Array.isArray(data)) {
            return data.map((item)=>this.transformations.reduce((result, transform)=>transform(result), item));
        }
        return this.transformations.reduce((result, transform)=>transform(result), data);
    }
    excludeNulls() {
        this.transformations.push((data)=>{
            return Object.entries(data).reduce((result, [key, value])=>{
                if (value !== null) {
                    result[key] = value;
                }
                return result;
            }, {});
        });
        return this;
    }
    transformToBoolean(booleanProps) {
        this.transformations.push((data)=>{
            return Object.entries(data).reduce((result, [key, value])=>{
                if (booleanProps.includes(key)) {
                    result[key] = !!value;
                } else {
                    result[key] = value;
                }
                return result;
            }, {});
        });
        return this;
    }
    nestedExtract(nestedExtract) {
        this.transformations.push((data)=>{
            const result = _extends({}, data);
            Object.entries(nestedExtract).forEach(([key, path])=>{
                const value = path.reduce((acc, key)=>acc == null ? void 0 : acc[key], result);
                result[key] = value;
            });
            return result;
        });
    }
    constructor(){
        this.transformations = [];
    }
};
const builderGenerator = (_0)=>{
    let { mappings, transformFn, meta, excludeNullProps = true, booleanProps, nestedExtract } = _0, rest = _object_without_properties_loose(_0, [
        "mappings",
        "transformFn",
        "meta",
        "excludeNullProps",
        "booleanProps",
        "nestedExtract"
    ]);
    return ()=>{
        const builder = new ApiV3DataTransformationBuilder();
        if (nestedExtract) {
            builder.nestedExtract(nestedExtract);
        }
        if (excludeNullProps) {
            builder.excludeNulls();
        }
        if (booleanProps) {
            builder.transformToBoolean(booleanProps);
        }
        if ('allowed' in rest || 'excluded' in rest) {
            builder.filterColumns(rest);
        }
        if (meta) {
            builder.metaTransform(meta);
        }
        if (mappings) {
            builder.remapColumns(mappings);
        }
        if (transformFn) {
            builder.customTransform(transformFn);
        }
        return builder;
    };
};
const colOptionBuilder = builderGenerator({
    allowed: [
        'formula_raw',
        'fk_qr_value_column_id',
        'fk_barcode_value_column_id',
        'fk_related_model_id',
        'type',
        'fk_relation_column_id',
        'fk_rollup_column_id',
        'fk_lookup_column_id',
        'rollup_function'
    ],
    mappings: {
        formula_raw: 'formula',
        fk_qr_value_column_id: 'qr_value_field_id',
        fk_barcode_value_column_id: 'barcode_value_field_id',
        type: 'relation_type',
        fk_related_model_id: 'linked_table_id',
        fk_relation_column_id: 'link_field_id',
        fk_rollup_column_id: 'linked_table_lookup_field_id',
        fk_lookup_column_id: 'linked_table_lookup_field_id',
        linked_table_rollup_field_id: 'fk_rollup_column_id'
    }
});
const columnBuilder = builderGenerator({
    allowed: [
        'id',
        'title',
        'uidt',
        'cdf',
        'description',
        'meta',
        'colOptions'
    ],
    mappings: {
        uidt: 'type',
        cdf: 'default_value',
        meta: 'options'
    },
    meta: {
        snakeCase: true,
        metaProps: [
            'meta'
        ],
        mappings: {
            is12hrFormat: '12hr_format',
            isLocaleString: 'locale_string',
            showAsProgress: 'show_as_progress'
        },
        excluded: [
            'defaultViewColOrder',
            'singular',
            'plural'
        ],
        skipTransformFor: [
            'currency_locale',
            'currency_code',
            'icon',
            'iconIdx',
            'duration'
        ]
    },
    transformFn: (data)=>{
        let options = data.options || {};
        if (data.colOptions) {
            switch(data.type){
                case _nocodbsdk.UITypes.SingleSelect:
                case _nocodbsdk.UITypes.MultiSelect:
                    {
                        const choices = (data.colOptions.options || []).map((opt)=>{
                            const res = {
                                title: opt.title,
                                color: opt.color
                            };
                            if (opt.id) res.id = opt.id;
                            return res;
                        });
                        options.choices = choices;
                    }
                    break;
                default:
                    {
                        const additionalOptions = colOptionBuilder().build(data.colOptions) || {};
                        Object.assign(options, additionalOptions);
                    }
                    break;
            }
        }
        if (data.type === _nocodbsdk.UITypes.Checkbox) {
            const _ref = data.options || {}, { icon, iconIdx } = _ref, rest = _object_without_properties_loose(_ref, [
                "icon",
                "iconIdx"
            ]);
            // extract option meta and include only label and color
            options = rest;
            if (iconIdx) {
                var _checkboxIconList_iconIdx;
                options.icon = (_checkboxIconList_iconIdx = _nocodbsdk.checkboxIconList[iconIdx]) == null ? void 0 : _checkboxIconList_iconIdx.label;
            } else if (icon) {
                var _checkboxIconList_find;
                options.icon = (_checkboxIconList_find = _nocodbsdk.checkboxIconList.find((ic)=>ic.checked === (icon == null ? void 0 : icon['checked']))) == null ? void 0 : _checkboxIconList_find.label;
            }
        } else if (data.type === _nocodbsdk.UITypes.Rating) {
            const _ref = data.options || {}, { icon, iconIdx } = _ref, rest = _object_without_properties_loose(_ref, [
                "icon",
                "iconIdx"
            ]);
            // extract option meta and include only label and color
            options = rest;
            if (iconIdx !== undefined && iconIdx !== null) {
                var _ratingIconList_iconIdx;
                options.icon = (_ratingIconList_iconIdx = _nocodbsdk.ratingIconList[iconIdx]) == null ? void 0 : _ratingIconList_iconIdx.label;
            } else if (icon) {
                var _ratingIconList_find;
                options.icon = (_ratingIconList_find = _nocodbsdk.ratingIconList.find((ic)=>ic.full === (icon == null ? void 0 : icon['full']))) == null ? void 0 : _ratingIconList_find.label;
            }
        } else if (data.type === _nocodbsdk.UITypes.Duration) {
            const _ref = data.options || {}, { duration, duration_format } = _ref, rest = _object_without_properties_loose(_ref, [
                "duration",
                "duration_format"
            ]);
            const durationFormat = duration != null ? duration : duration_format;
            // extract option meta and include only label and color
            options = rest;
            if (durationFormat !== undefined && durationFormat !== null) {
                var _durationOptions_durationFormat;
                options.duration_format = (_durationOptions_durationFormat = _nocodbsdk.durationOptions[durationFormat]) == null ? void 0 : _durationOptions_durationFormat.title;
            }
        }
        return _extends({}, data, {
            colOptions: undefined,
            options: options || data.options
        });
    }
});
const columnOptionsV3ToV2Builder = builderGenerator({
    allowed: [
        'formula',
        'qr_value_field_id',
        'barcode_value_field_id',
        'relation_type',
        'linked_table_id',
        'link_field_id',
        'linked_table_rollup_field_id',
        'linked_table_lookup_field_id',
        'rollup_function'
    ],
    mappings: {
        formula: 'formula_raw',
        qr_value_field_id: 'fk_qr_value_column_id',
        barcode_value_field_id: 'fk_barcode_value_column_id',
        relation_type: 'type',
        // parent id we need to extract from the url
        linked_table_id: 'childId',
        link_field_id: 'fk_relation_column_id',
        linked_table_rollup_field_id: 'fk_rollup_column_id',
        linked_table_lookup_field_id: 'fk_lookup_column_id'
    }
});
const columnV3ToV2Builder = builderGenerator({
    allowed: [
        'id',
        'title',
        'type',
        'default_value',
        'options'
    ],
    mappings: {
        type: 'uidt',
        default_value: 'cdf',
        options: 'meta'
    },
    meta: {
        snakeCase: false,
        camelCase: true,
        metaProps: [
            'options'
        ],
        mappings: {
            '12hr_format': 'is12hrFormat',
            locale_string: 'isLocaleString',
            show_as_progress: 'showAsProgress'
        },
        skipfn: (data)=>columnsWithOptions.includes(data.uidt || data.type),
        excluded: [
            'defaultViewColOrder',
            'singular',
            'plural'
        ],
        skipTransformFor: [
            'currency_locale',
            'currency_code',
            'icon',
            'iconIdx',
            'duration_format'
        ]
    },
    transformFn: (data)=>{
        let meta = data.meta || {};
        let colOptions;
        switch(data.uidt){
            case _nocodbsdk.UITypes.SingleSelect:
            case _nocodbsdk.UITypes.MultiSelect:
                {
                    const choices = data.meta.choices.map((opt)=>{
                        const res = {
                            title: opt.title,
                            color: opt.color
                        };
                        if (opt.id) res.id = opt.id;
                        return res;
                    });
                    colOptions = {
                        options: choices
                    };
                }
                break;
            default:
                break;
        }
        if (data.uidt === _nocodbsdk.UITypes.Checkbox) {
            const _ref = data.meta || {}, { icon } = _ref, _rest = _object_without_properties_loose(_ref, [
                "icon"
            ]);
            if (icon) {
                const iconIdx = _nocodbsdk.checkboxIconList.findIndex((ic)=>ic.label === icon);
                if (iconIdx !== -1) {
                    const _checkboxIconList_iconIdx = _nocodbsdk.checkboxIconList[iconIdx], { label: _ } = _checkboxIconList_iconIdx, rest = _object_without_properties_loose(_checkboxIconList_iconIdx, [
                        "label"
                    ]);
                    meta.iconIdx = iconIdx;
                    meta.icon = rest;
                }
            }
        } else if (data.uidt === _nocodbsdk.UITypes.Rating) {
            const _ref = data.meta || {}, { icon } = _ref, _rest = _object_without_properties_loose(_ref, [
                "icon"
            ]);
            if (icon) {
                const iconIdx = _nocodbsdk.ratingIconList.findIndex((ic)=>ic.label === icon);
                if (iconIdx !== -1) {
                    const _ratingIconList_iconIdx = _nocodbsdk.ratingIconList[iconIdx], { label: _ } = _ratingIconList_iconIdx, rest = _object_without_properties_loose(_ratingIconList_iconIdx, [
                        "label"
                    ]);
                    meta.iconIdx = iconIdx;
                    meta.icon = rest;
                }
            }
        } else if (data.uidt === _nocodbsdk.UITypes.Duration) {
            const _ref = data.meta || {}, { duration, duration_format } = _ref, rest = _object_without_properties_loose(_ref, [
                "duration",
                "duration_format"
            ]);
            const durationFormat = duration != null ? duration : duration_format;
            // extract option meta and include only label and color
            const durationIdx = _nocodbsdk.durationOptions.findIndex((d)=>d.title === durationFormat);
            if (durationIdx > -1) {
                meta.duration = durationIdx;
                Object.assign(meta, rest);
            }
        }
        let additionalPayloadData = {};
        if (columnsWithOptions.includes(data.uidt) && data.meta) {
            additionalPayloadData = columnOptionsV3ToV2Builder().build(data.meta) || {};
            meta = {};
        }
        return _extends({}, data, {
            colOptions,
            meta: meta || data.meta
        }, additionalPayloadData);
    }
});
